import React, {FC, useState} from 'react';

import {FrontEvent} from '../../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {BulkActionsTrackingTypesEnum} from '../../../../../../../libs/shared/core/src/services/tracking/tracking';
import {CellsContext} from '../../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {DropdownProps} from '../../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {ViewerDropdownInterfaceEventSourcesEnum} from '../../../../../../helpers/models/tagHelpers';
import {ConversationBaseModel} from '../../../../../../models/api/conversationModel';
import {LegacyConversationLinkDropdownEntryPointModel} from '../../../../../../models/api/legacyEntryPointModel';
import {TagModel} from '../../../../../../models/api/tagModel';
import {InboxesParameters} from '../../../../../../store/panels/inboxes/parameters/inboxesParameters';
import {AddTopicOrTagDropdownContainer} from '../../header/topicsAndTags/addTopicOrTagDropdownContainer';

/*
 * Props.
 */

interface ConversationsTagDropdownProps extends DropdownProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  inboxesParameters: InboxesParameters;
  /** Potentially partial set of currently selected conversation. */
  conversations: ReadonlyArray<ConversationBaseModel>;
  isBulkActionRequired: boolean;
  onCreateTagSelect: (e: FrontEvent, name: string) => void;
  onAddTopicSelect: ((event: FrontEvent) => void) | undefined;
  onEntryPointSelect: ((model: LegacyConversationLinkDropdownEntryPointModel) => void) | undefined;
  onInterfaceEvent?: (action: BulkActionsTrackingTypesEnum, isBulk: boolean) => void;
  interfaceEventSource: ViewerDropdownInterfaceEventSourcesEnum;
}

/*
 * Component.
 */

export const ConversationsTagDropdown: FC<ConversationsTagDropdownProps> = (props) => {
  const [navigationTagsPath, setNavigationTagsPath] = useState<ReadonlyArray<TagModel>>([]);
  const [searchQuery, setSearchQuery] = useState<string>('');

  const placementValue =
    props.interfaceEventSource === ViewerDropdownInterfaceEventSourcesEnum.TOPBAR ? 'bottom-end' : 'top-end';

  return (
    <AddTopicOrTagDropdownContainer
      {...props}
      placement={placementValue}
      navigationTagsPath={navigationTagsPath}
      setNavigationTagsPath={setNavigationTagsPath}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    />
  );
};
